import { render, staticRenderFns } from "./withdrawGuide.vue?vue&type=template&id=daf873f6&scoped=true&"
import script from "./withdrawGuide.vue?vue&type=script&lang=js&"
export * from "./withdrawGuide.vue?vue&type=script&lang=js&"
import style0 from "./withdrawGuide.vue?vue&type=style&index=0&id=daf873f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf873f6",
  null
  
)

export default component.exports